"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgOneWay(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M4 0h16v16H4zm5 6h2v7h2V6h2l-3-3z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('OneWay')(SvgOneWay);
//# sourceMappingURL=OneWay.js.map